import React from "react";
import { MapPin, Quote, Star } from "lucide-react";
import { Card, CardContent } from "./Card";
import { testimonials, testimonialsExpanded } from "../data/content";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
type TestimonialsProps = {
  expanded?: boolean;
};
const avatarColors = ["bg-[#E3262E] shadow-[0_8px_24px_rgba(227,38,46,0.25)]", "bg-[#0B3563] shadow-[0_8px_24px_rgba(11,53,99,0.35)]", "bg-[#A96A16] shadow-[0_8px_24px_rgba(169,106,22,0.25)]"];
export function Testimonials({
  expanded = false
}: TestimonialsProps) {
  const items = expanded ? testimonialsExpanded : testimonials;
  return <Reveal className={`px-5 sm:px-8 lg:px-12 ${expanded ? "bg-[#0D1424] py-20" : "bg-[#080B14] pb-20 pt-12"}`} data-id="element-236" data-mp="2x2mnlx6n34vu">
      <div className="mx-auto max-w-[1180px]" data-id="element-237" data-mp="v9g9pm6l60om">
        {expanded && <SectionHeading eyebrow="Experiencias reales" title="Profes que dejaron de improvisar" subtitle="Más profes que recuperaron tiempo y mejoraron la calidad de sus clases." data-id="element-238" data-mp="v8nar7dvcfh1" />}
        <div className="grid gap-4 lg:grid-cols-3" data-id="element-239" data-mp="m4rowevdji7h">
          {items.map((item, index) => {
          const initials = item.name.split(" ").map(part => part.charAt(0)).join("").replace(".", "").slice(0, 2).toUpperCase();
          return <Card key={item.name} className="group relative overflow-hidden border-[#0B3563] bg-[#0A1A33] text-white shadow-[0_18px_55px_rgba(0,0,0,0.3)] transition-[transform,border-color,box-shadow] duration-200 hover:-translate-y-1 hover:border-[#F5B83D]/35 hover:shadow-[0_24px_65px_rgba(0,0,0,0.4)]" data-id="element-240" data-mp="zwy2bt757b38" data-mpi={index}>
                <div className="absolute inset-x-0 top-0 h-px bg-[linear-gradient(90deg,transparent,#F5B83D,transparent)] opacity-60" data-id="element-241" data-mp="1ivk316yqz06m" />
                <CardContent className="flex h-full min-h-[330px] flex-col p-6 sm:p-7" data-id="element-242" data-mp="1nmscg302uljs">
                  <div className="flex items-start justify-between gap-4" data-id="element-243" data-mp="1xgxzxcbaibnh">
                    <div className="flex gap-1 text-[#F5B83D]" aria-label="5 de 5 estrellas" data-id="element-244" data-mp="1sieb945balrf">
                      {[1, 2, 3, 4, 5].map(star => <Star key={star} className="size-[18px] fill-current" aria-hidden="true" data-id="element-245" data-mp="1ofhod18qo3ho" />)}
                    </div>
                    <Quote className="size-10 stroke-[1.5] text-[#C7CED8]" aria-hidden="true" data-id="element-246" data-mp="1ejoe5oihsm32" />
                  </div>

                  <blockquote className="mt-5 flex-1 text-[15px] italic leading-7 text-[#F7F4EC] sm:text-base" data-id="element-247" data-mp="19rdcoh83ss8e">
                    “{item.quote}”
                  </blockquote>

                  <div className="mt-6 flex items-center gap-4 border-t border-white/[0.08] pt-5" data-id="element-248" data-mp="10s9stb1448su">
                    <div className={`flex size-12 shrink-0 items-center justify-center rounded-full text-base font-black text-white ${avatarColors[index % avatarColors.length]}`} aria-hidden="true" data-id="element-249" data-mp="vt6ltl1knsi8">
                      {initials}
                    </div>
                    <div className="min-w-0" data-id="element-250" data-mp="32j06utwhr5b4">
                      <div className="flex flex-wrap items-center gap-x-2 gap-y-1" data-id="element-251" data-mp="37f7hgzzu14ze">
                        <p className="font-black text-white" data-id="element-252" data-mp="3cfd3o0nc1za3">{item.name}</p>
                        <span className="text-[#E3262E]" aria-hidden="true" data-id="element-253" data-mp="3cd905jtcj2ac">•</span>
                        <p className="flex items-center gap-1 text-sm text-[#AAB7C8]" data-id="element-254" data-mp="3geks3vzozzlp">
                          <MapPin className="size-3.5 shrink-0 text-[#E3262E]" aria-hidden="true" data-id="element-255" data-mp="2jrz92973xft5" />
                          {item.location}
                        </p>
                      </div>
                      <p className="mt-2 text-[10px] font-black uppercase leading-4 tracking-[0.1em] text-[#F5B83D]" data-id="element-256" data-mp="2spjgy0zh6acq">{item.role}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </Reveal>;
}